import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserService } from '../../../../@shared/services/user.service';
import { AuthUserService } from '../../../../@shared/services/auth/auth-user.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-user-inventory',
  templateUrl: './user-inventory.component.html',
  styleUrls: ['./user-inventory.component.scss']
})
export class UserInventoryComponent implements OnInit, OnDestroy {
  private readonly resetInventoryRoles: string[] = [
    'main_owner',
    'main_admin',
    'main_moderator'
  ];
  private readonly destroyed$: Subject<void> = new Subject<void>();

  public isGoFast: boolean = environment.projectName === 'CSGOFAST';
  public isLoading: boolean = true;
  public isResetting: boolean = false;
  public canResetInventory: boolean = false;
  public userInventory: any;
  public totalInventorySum: number = 0;

  constructor(
    private userService: UserService,
    private authUserService: AuthUserService
  ) {}

  ngOnInit(): void {
    this.authUserService.user$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user: any) => {
        this.canResetInventory =
          user?.roles?.some((role: string) =>
            this.resetInventoryRoles.includes(role)
          ) || false;
      });

    this.loadInventory();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public resetInventory(): void {
    const userId = this.userService.currentUserId.getValue();
    if (
      !confirm(
        `Обнулить инвентарь пользователя ${userId}? Действие необратимо.`
      )
    ) {
      return;
    }

    this.isResetting = true;
    this.userService
      .resetUserInventory()
      .pipe(
        finalize(() => (this.isResetting = false)),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.loadInventory());
  }

  private loadInventory(): void {
    this.isLoading = true;
    this.userService
      .getUserInventory()
      .pipe(
        finalize(() => (this.isLoading = false)),
        takeUntil(this.destroyed$)
      )
      .subscribe(data => {
        this.userInventory = Array.isArray(data) ? data : data?.items || [];
        this.totalInventorySum =
          data?.totalSum ??
          this.userInventory.reduce(
            (acc: number, item: any) => acc + (item?.inventoryItem?.price ?? 0),
            0
          );
      });
  }
}
